module.exports = __webpack_public_path__ + "svg/cloud-rocket.8e5843f2ce6877a562e02211ed5ec16d.svg";